module.exports = __webpack_public_path__ + "images/icons_v2/expand-a6871407.svg";